import { t } from "i18next";

import ExclamationMarkIcon from "../../../../assets/icons/ExclamationMarkIcon";
import WaterDropIcon from "../../../../assets/icons/WaterDropIcon";
import useWindowSize from "../../../../hooks/useWindowSize";
import MenuTile from "../../../Shared/MenuTile";

function Menu() {
  const window = useWindowSize();

  return (
    <>
      {window?.width > 768 && (
        <h1 className="page-title mb-0 text-center sm:text-left !text-triple-blue">
          {t("report.reports")}
        </h1>
      )}

      {window?.width <= 768 && (
        <h1 className="page-title-mobile mb-0 text-center sm:text-left uppercase !text-triple-blue">
          {t("report.reports")}
        </h1>
      )}

      <div className="mt-2 flex md:flex-row flex-col md:items-start items-center gap-5">
        <MenuTile
          title={t("report.consumption")}
          icon={
            <WaterDropIcon
              className="w-12 h-12 xxxl:w-20 xxxl:h-20 align-sub"
              strokeColor="#757782"
            />
          }
          navigateTo="/reports/consumption/water"
        />
        <MenuTile
          title={t("report.status")}
          icon={<ExclamationMarkIcon />}
          navigateTo="/reports/status"
        />
      </div>
    </>
  );
}

export default Menu;
